<div class="container">
    <div *ngIf="!bahome" [ngClass]="{'container2': ispotrait, 'container2a': !ispotrait}">
        <div [ngClass]="{'container3': !ispotrait, 'container3a': ispotrait}" (click)="homeiconclick()">
            <!-- <img [ngClass]="{'container3img': !ispotrait, 'container3aimg': ispotrait}" [src]="'assets/images/'+environment.project+'.svg'"> -->
            <img [ngClass]="{'container3img': !ispotrait, 'container3aimg': ispotrait}" [src]="'assets/images/BA.svg'">
        </div>
        <div class="container4">
            <h1 class="timetextcolor" [ngClass]="{'h11': !ispotrait, 'h21': ispotrait}">{{time}}</h1>
            <button class="commoncss" mat-stroked-button (click)="langclick()" style="outline: none; border: none; padding: 0.5vh; border-radius: 5px; margin-left: 2vh; min-width: 12vh;">
                <span style="display: flex; justify-content: center; align-items: center;">
                    <img [src]="setimage()" [ngStyle]="{'height': ispotrait ? '2vh' : '2vw'}" style="width: auto; margin-right: 2vw;" alt="flagimage"><span style="color: black;" [ngStyle]="{'font-size': ispotrait ? '2vh' : '2vw'}">{{langvalue | uppercase}}</span>
                    <!-- <mat-icon class="commoncss">{{!showlang ? 'keyboard_arrow_down' : 'keyboard_arrow_up'}}</mat-icon> -->
                </span>
            </button>
            <!-- <mat-card *ngIf="showlang" [ngStyle]="{'top': ispotrait ? '5vh' : '10vh' , 'right': ispotrait ? '3vw' : '2.5vw'}" style="position: absolute; z-index: 1092; padding: 0 2.5vh; background: white;">
                <div style="height: auto; width: auto; background: white;">
                    <div *ngFor="let lang of langlist; let i = index">
                        <div [id]="'language' + i" style="width: 100%; padding: 1vh 0; display: flex; justify-content: space-between; align-items: center; flex-direction: row;" (click)="changelang(lang)">
                            <div style="display: flex; justify-content: center; align-items: center; width: 50%;">
                                <img [src]="'../assets/images/airlineLogos/' + lang.code + 'flag.svg'" [ngStyle]="{'height': ispotrait ? '2vh' : '2vw'}" style="width: auto; margin-right: 2vw;" alt="flagimage">
                            </div>
                            <div style="display: flex; justify-content: flex-start; align-items: center; width: 50%;" [ngStyle]="{'font-size': ispotrait ? '2vh' : '2vw'}">
                                {{lang.code | uppercase}}
                            </div>
                        </div>
                        <mat-divider style="width: 100%;"></mat-divider>
                    </div>
                </div>
            </mat-card> -->
            <div (click)="notificationiconclick()" style="display: flex; justify-content: center; align-items: flex-start;">
                <img [src]="notificationicon()" alt="">
            </div>
            <!-- <h1 [ngClass]="{'h12': !ispotrait, 'h22': ispotrait}">{{day | uppercase}}, {{date}} {{month | uppercase}}</h1> -->
        </div>
    </div>
    <div [ngStyle]="{'top': bahome ? 0:'', 'height':bahome ? '100vh' : ''}" [ngClass]="{'container5': ispotrait , 'container5a': !ispotrait, 'containerr': rotated}">
        <router-outlet></router-outlet>
        <footer *ngIf="!bahome" style="z-index: 1091; position: fixed; bottom: 0%;">
            <div class="backgroundcolor" [ngClass]="{'powerdclass': langcode == 'En', 'poweredclassit': langcode == 'It', 'poweredclassitp': (langcode == 'It' && !ispotrait) }">
                <div *ngIf="environment.project =='ADR'">
                    <h1 class="poweredclassh"><u (click)="opneprivacy('privacy')">{{langconfig.privacyp}}</u> | <u (click)="opneprivacy('Legal')">{{langconfig.legaln}}</u></h1>
                </div>
                <div [ngClass]="environment.project != 'ADR' ? 'heathrowclass' : ''">
                    <h1 class="poweredclassh">{{langconfig.poweredby}}<span (click)="openwebsite('https://www.zestiot.com/')"><u>ZestIoT</u></span></h1>
                    <!-- <h1 class="poweredclassh">{{langconfig.poweredby}}<span (click)="openwebsite()"><u>{{environment.project}}</u></span> & <span (click)="openwebsite('https://www.zestiot.com/')"><u>ZestIoT</u></span></h1> -->
                </div> 
            </div>
        </footer>
    </div>
    <!-- <footer *ngIf="!ispotrait" style="z-index: 1091;">
        <div class="powerdclass">
            <div>
                <h1 class="poweredclassh"><u (click)="opneprivacy('privacy')">Privacy policy</u> | <u (click)="opneprivacy('Legal')">Legal notice</u></h1>
            </div>
            <div>
                <h1 class="poweredclassh">Powered by <span (click)="openwebsite('https://www.adr.it/')"><u>ADR</u></span> & <span (click)="openwebsite('https://www.zestiot.com/')"><u>ZestIoT</u></span></h1>
            </div> 
        </div>
    </footer> -->
</div>
<ng-template #DialogComponent>
    <div style="height: 10em; width: 20em; background: white; border-radius: 15px; overflow: hidden; flex-direction: column;" class="commoncss">
      <div style="display: flex; align-items: center; height: 100%;">
        <h4 style="font-size: 1.1em;">{{this.langconfig ? this.langconfig.datamessage : ''}}</h4>
      </div>
      <hr style="margin: 0 !important; width: 100%;">
      <div style="width: 100%; background: #f9f9f9; flex-direction: column;" class="commoncss">
        <h4 (click)="closedialog()" style="font-size: 1.2em; padding: 0.3em 0; width: 100%; cursor: pointer; color: #67A9FC;" class="commoncss">{{this.langconfig ? this.langconfig.close: 'close'}}</h4>
      </div>
    </div>
  </ng-template>
<ng-template #privacycomponent>
    <div style="max-height: 78vh; min-height: 20vh; left:0; width: auto; position: absolute; bottom: 3vh; background: white; border-radius: 15px; overflow: hidden; display: flex; justify-content: center; align-items: center; flex-direction: column;">
        <app-privacycomponent [datatype]="datatype"></app-privacycomponent>
        <div style="width: 100%; height: 10vh; margin-bottom: 5vh; display: flex; justify-content: center; align-items: center;">
            <button class="font-color" [ngStyle]="{'width': ispotrait ? '30vw' : '15vw'}" (click)="closedialog()" style="height: auto; background: #ebedf7; outline: none; border: 1px solid #3343ad; border-radius: 1vh; font-size: 2.5vh; font-weight: 500;">{{langconfig.close}}</button>
        </div>
    </div>
</ng-template>
<ng-template #notificationComponent>
    <div style="height: 18em; width: 28em; background: white; border-radius: 15px; overflow: hidden; display: flex; justify-content: center; align-items: center; flex-direction: column;">
      <div style="display: flex; width: 100%; flex-direction: column; align-items: flex-start; justify-content: flex-start; height: 100%;">
        <h4 style="font-size: 1.5em; margin: 1em; text-align: center;">{{langconfig ? langconfig.enablenotify : ''}}</h4>
        <h4 style="font-size: 1.2em; margin: 0 1em; text-align: left;">
          {{langconfig ? langconfig.notificationmsg : ''}}
        </h4>
        <br>
        <h4 style="font-size: 1em; margin: 0 1em; text-align: left;">
            {{langconfig ? langconfig.notificationmsg2 : ''}}
        </h4>
      </div>
      <div style="width: 100%; display: flex; flex-direction: row; justify-content: flex-end; align-items: center; gap: 1em; padding: 1vh 2vw;">
        <div style="padding: 0.5em;">
          <h4 class="font-color" (click)="closedialog1()" style="font-size: 1.3em; padding-top: 0.3em; width: 100%; display: flex; justify-content: center; cursor: pointer;">{{langconfig? langconfig.cancel : ''}}</h4>
        </div>
        <div class="backgroundcolor" style="padding: 0.5em 1em; border-radius: 1em;">
          <h4 (click)="closedialog1('confirm')" style="font-size: 1.3em; padding-top: 0.3em; width: 100%; display: flex; justify-content: center; cursor: pointer; color: #fff;">{{langconfig? langconfig.enable : ''}}</h4>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #nopermission>
    <div style="height: 12em; width: 28em; background: white; border-radius: 15px; overflow: hidden; display: flex; justify-content: center; align-items: center; flex-direction: column;">
      <div style="display: flex; width: 100%; flex-direction: column; align-items: center; justify-content: center; height: 100%;">
        <h4 style="font-size: 1.8vh; font-weight: 500; margin: 0 1em; text-align: left; display: flex; justify-content: center; align-items: center; gap: 1vw;"> 
          <span>
            <mat-icon style="color: #3C3C4399; font-size: 2.5vh;">info</mat-icon>
          </span>
          Allow notifications  {{devicedetails.os !='iOS' ? 'in your browser and refresh this page' : 'and open the Application'}} to get real-time updates
        </h4>
      </div>
      <div style="width: 100%; display: flex; flex-direction: row; justify-content: flex-end; align-items: center; gap: 1em; padding: 0.5em 2em;">
        <div style="padding: 0.5em;">
            <h4 (click)="closedialog2()" style="color: #004f9f; font-size: 1.3em; padding-top: 0.3em; width: 100%; display: flex; justify-content: center; cursor: pointer;">Close</h4>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #iOSpopup>
    <div style="min-height: 12em; height: auto; min-width: 28em; width: auto; background: white; border-radius: 15px; overflow: hidden; display: flex; justify-content: center; align-items: center; flex-direction: column;">
      <div style="display: flex; width: 100%; flex-direction: column; align-items: center; justify-content: center; height: 100%; margin: 2em; gap: 2em;">
        <div style="width: 100%;">
          <h4 style="font-size: 2vh; font-weight: 600; margin: 0 1em; text-align: center; display: flex; justify-content: center; align-items: flex-start; gap: 1vw;"> 
              <span>
                  <img style="height: 2.3vh; width: auto;" src="assets/images/info.svg" alt="">
              </span>
              Receive Flight Notifications
          </h4>
        </div>
        <div style="display: flex; justify-content: center; align-items: flex-start; width: 100%; flex-direction: column;  gap: 0.5em;">
          <div *ngFor="let list of stepslist; let i = index" style="display: flex; justify-content: center; align-items: flex-start; flex-direction: column;">
            <h1 style="font-size: 1.8vh; font-weight: 500; margin: 0 1em; text-align: left; display: flex; justify-content: flex-start; align-items: flex-start; gap: 0.5em;">
              <span>{{i+1 + "."}}</span> {{ list}}</h1>
          </div>
          <div style="display: flex; justify-content: center; align-items: center; flex-direction: column;">
            <h1 style="font-size: 1.8vh; font-weight: 500; margin:1em; text-align: left; display: flex; justify-content: flex-start; align-items: flex-start;">
              Get instant notifications and stay well-
              informed about all aspects of your flight,
              including real-time updates on status
              changes, gate information, closing times, and
              other pertinent details</h1>
          </div>
        </div>
      </div>
      <div style="width: 100%; display: flex; flex-direction: row; justify-content: flex-end; align-items: center; gap: 1em; padding: 0.5em 2em;">
        <div style="padding: 0.5em;">
            <h4 (click)="closedialog2()" style="color: #004f9f; font-size: 1.3em; padding-top: 0.3em; width: 100%; display: flex; justify-content: center; cursor: pointer;">Close</h4>
        </div>
      </div>
    </div>
  </ng-template>